import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LoadingButton } from '@mui/lab'
import { Grid, InputAdornment } from '@mui/material'
import { PhoneInput, TextHookField } from '@procom-labs/molecules'

import { Header } from '@auth-portal/components/header'
import { LandingFormValues } from '@auth-portal/types'

export const HmCreationForm: React.FC<{
  isLoading: boolean
}> = ({ isLoading }) => {
  const { t } = useTranslation('main')
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<LandingFormValues>()
  return (
    <Grid
      display="flex"
      flexDirection="column"
      rowGap={2}
      sx={{
        px: {
          xs: 1,
          sm: 4,
          lg: 5,
          xl: 7,
          k2: 12.5,
        },
      }}
    >
      <Header heading={t('form.createAccount.headings.title2')} />

      <TextHookField
        control={control}
        name="firstName"
        type="text"
        required
        label={t('form.createAccount.firstName')}
        customLabel={false}
        InputLabelProps={{
          shrink: false,
        }}
      />
      <TextHookField
        control={control}
        name="lastName"
        type="text"
        required
        label={t('form.createAccount.lastName')}
        customLabel={false}
        InputLabelProps={{
          shrink: false,
        }}
      />

      <TextHookField
        control={control}
        name="phoneNumber"
        required
        label={t('form.createAccount.phoneNumber')}
        customLabel={false}
        InputProps={{
          inputComponent: PhoneInput,
          startAdornment: <InputAdornment position="start">+1</InputAdornment>,
        }}
        InputLabelProps={{
          shrink: false,
        }}
      />

      <LoadingButton
        size="large"
        type="submit"
        color="secondary"
        variant="contained"
        fullWidth
        loading={isLoading || isSubmitting}
      >
        {t('common.btn.submit')}
      </LoadingButton>
    </Grid>
  )
}
